window.addEventListener("load", (event) =>{

});

;(function () {
  jQuery('.carousel').on('slide.bs.carousel', function ({ relatedTarget }) {
    let title = jQuery('#colorLabel12')
    let color = jQuery(relatedTarget).data('color')
    title.text(color)
  })
})()

function changeImageColor(folder, image1, image2, text, noLabel) {
  let btn = jQuery(`.btn${text.replace(' ', '_')}`)
  jQuery('.btnColores').removeClass('active')
  btn.addClass('active')
  jQuery('#image-Color-Change1').attr('src', image1)
  jQuery('#image-Color-Change2').attr('src', image2)

  switch (noLabel) {
    case '1':
      var element1 = document.getElementById('colorLabel12')
      element1.textContent = text
      break
    case '2':
      var element1 = document.getElementById('colorLabel11')
      var element2 = document.getElementById('colorLabel12')
      element1.textContent = text
      element2.textContent = text
      break
    case '3':
      var element1 = document.getElementById('colorLabel10')
      var element2 = document.getElementById('colorLabel12')
      var element3 = document.getElementById('colorLabel09')
      element1.textContent = text
      element2.textContent = text
      element3.textContent = text
      break
    default:
      break
  }
}

function swivel_option1(){
  // 7th - 9th gen
  const dimensions = "10.12 x 7.92 x 1.09 in / 25.71 x 20.12 x 2.76 cm";
  const Weight = "0.314 kg / 0.692 lbs";
  const materials = "PC / TPU";

  const dimensionLabel = document.getElementById("txt_dimensions");
  const weightLabel = document.getElementById("txt_weight");
  const materialLabel = document.getElementById("txt_materials");

  dimensionLabel.textContent = dimensions;
  weightLabel.textContent = Weight;
  materialLabel.textContent = materials;

  document.getElementById("img_7_9_gen").style.opacity = "1";
  document.getElementById("img_10_gen").style.opacity = "0.5";

}

function swivel_option2(){
  // 10 gen
  const dimensions = "10.19 x 7.7 x 1.24 in / 25.90 x 19.72 x 2.81 cm";
  const Weight = "0.32 kg /  0.705 lbs";
  const materials = "PC / TPU";

  const dimensionLabel = document.getElementById("txt_dimensions");
  const weightLabel = document.getElementById("txt_weight");
  const materialLabel = document.getElementById("txt_materials");

  dimensionLabel.textContent = dimensions;
  weightLabel.textContent = Weight;
  materialLabel.textContent = materials;

  document.getElementById("img_7_9_gen").style.opacity = "0.5";
  document.getElementById("img_10_gen").style.opacity = "1";
}

function ipad12() {
  let tempNode
  tempNode = document.getElementById('Ipad12')
  if (tempNode.nodeType) {
    tempNode.classList.remove('displayNone')
  }
  tempNode = document.getElementById('Ipad10')
  if (document.getElementById('Ipad10')) {
    tempNode.classList.add('displayNone')
  }
  tempNode = document.getElementById('Ipad09')
  if (document.getElementById('Ipad09')) {
    tempNode.classList.add('displayNone')
  }
  tempNode = document.getElementById('Ipad11')
  if (document.getElementById('Ipad11')) {
    tempNode.classList.add('displayNone')
  }
}

function ipad11() {
  let tempNode
  tempNode = document.getElementById('Ipad12')
  if (tempNode.nodeType) {
    tempNode.classList.add('displayNone')
  }
  tempNode = document.getElementById('Ipad10')
  if (document.getElementById('Ipad10')) {
    tempNode.classList.add('displayNone')
  }
  tempNode = document.getElementById('Ipad09')
  if (document.getElementById('Ipad09')) {
    tempNode.classList.add('displayNone')
  }
  tempNode = document.getElementById('Ipad11')
  if (document.getElementById('Ipad11')) {
    tempNode.classList.remove('displayNone')
  }
}

function duxDuo_option1(){ 
  // 7th - 9th gen
  
  const dimensions = "10.04 x 7.64 x 0.67 in / 25.5 x 19.41 x 1.7 cm";
  const Weight = "0.75 lbs / 0.339 kg";
  const materials = "100% TPU with Polycarbonate Back.";

  const dimensionLabel = document.getElementById("txt_dimensions");
  const weightLabel = document.getElementById("txt_weight");
  const materialLabel = document.getElementById("txt_materials");

  dimensionLabel.textContent = dimensions;
  weightLabel.textContent = Weight;
  materialLabel.textContent = materials;

  document.getElementById("txt_ipad_gen").textContent = "iPad 7th/8th/9th gen";
  document.getElementById("txt_compatible").textContent = " iPad 7th/8th/9th gen";

  document.getElementById("img_7_9_gen_duo").style.opacity = "1";
  document.getElementById("img_10_gen_duo").style.opacity = "0.5";
}

function duxDuo_option2(){
  // 10 gen
  const dimensions = "10.1 x 7.7 x 19.56 in / 25.65 x 23 x 1.524 cm";
  const Weight = "0.7 lbs / 0.476 kg";
  const materials = "100% TPU with Polycarbonate Back.";

  const dimensionLabel = document.getElementById("txt_dimensions");
  const weightLabel = document.getElementById("txt_weight");
  const materialLabel = document.getElementById("txt_materials");

  dimensionLabel.textContent = dimensions;
  weightLabel.textContent = Weight;
  materialLabel.textContent = materials;

  document.getElementById("txt_ipad_gen").textContent = "iPad (A16)/10th gen.";
  document.getElementById("txt_compatible").textContent = " iPad (A16)/10th gen.";

  document.getElementById("img_7_9_gen_duo").style.opacity = "0.5";
  document.getElementById("img_10_gen_duo").style.opacity = "1";
}